import React, {
  useRef,
  useEffect,
  useState,
  useMemo,
} from 'react';
import styled from 'styled-components/macro';
import { Row, Col } from '../grid';
import { LinkButton, Heading3 } from '../typography';
import Modal from '../Modal';
import { ItemTraverser } from '../../containers/commerce';
import HuskView from '../commerce/ProductViews/HuskView';

const StyledModal = styled(Modal)`
  z-index: 99999999999;
  position: fixed;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  background: ${({ theme }) => theme.colors.colorWhite};
  border: 2px ${({ theme }) => theme.colors.colorGreyLightAlt} solid;
  outline: none;
  overflow-x: hidden;
  
  width: calc(80% - 100px);
  max-height: calc(80% - 100px);
  padding: 20px;

  @media (max-width: 1199px) {
    width: calc(100% - 100px);
  }

  @media (max-width: 991px) {
    width: calc(100% - 100px);
    top: 30px !important;
    transform: translate(-50%,0%) !important;
    max-height: calc(100% - 160px);
  }
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;

  @media (max-width: 575px) {
    grid-template-columns: 1fr;
  }
`;
const Left = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 575px) {
    display: none;
  }
`;
const Right = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media (max-width: 575px) {
    justify-content: center;
  }
`;
export default ({
  isOpen,
  onClose,
  hasIs,
  hasGlass,
}) => {
  const [renderTime, setRenderTime] = useState(0);
  const isRef = useRef(hasIs);
  const { current: originallyHadIs } = isRef;
  const glassRef = useRef(hasGlass);
  const { current: originallyHadGlass } = glassRef;
  const isOpenRef = useRef(isOpen);
  const { current: originallyHadIsOpen } = isOpenRef;
  useEffect(() => {
    const wasOpen = originallyHadIsOpen;
    isOpenRef.current = isOpen;
    if (!wasOpen && (originallyHadIs !== hasIs || originallyHadGlass !== hasGlass)) {
      isRef.current = hasIs;
      glassRef.current = hasGlass;
      setRenderTime(renderTime + 1);
    }
  });
  const includeItemTraverserCategories = useMemo(
    () => {
      const ret = [];
      if (!originallyHadGlass) {
        ret.push('huskGlas');
      }
      if (!originallyHadIs) {
        ret.push('huskIs');
      }
      return ret;
    },
    [originallyHadGlass, originallyHadIs],
  );
  return (
    <StyledModal
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <Row>
        <Col xs={12} textCenter>
          <Grid>
            <Left>
              <Heading3 marginBottom="0">Vi anbefaler:</Heading3>
            </Left>
            <Right>
              <LinkButton small action onClick={onClose}>
                Gå videre til kassen
              </LinkButton>
            </Right>
          </Grid>
        </Col>
      </Row>
      <ItemTraverser includedCategories={includeItemTraverserCategories} inclusionMode='UNION' display={HuskView} />
      <Row>
        <Col xs={12} textCenter>
          <LinkButton small action justifyCenter onClick={onClose}>
            Gå videre til kassen
          </LinkButton>
        </Col>
      </Row>
    </StyledModal>
  )
};
